import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { TabsContent } from "@/components/ui/tabs";
import { EmptyState, StatusBadge } from "@/components/bits";
import api, { errMsg } from "@/lib/api";

export function LeavesTab({ leaves, onRefresh }) {
  const reviewLeave = async (id, action) => {
    try {
      await api.post(`/employer/leaves/${id}/review`, { action });
      toast.success(`Leave ${action}d`);
      onRefresh();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <TabsContent value="leaves">
      {leaves.length === 0 ? (
        <EmptyState title="No leave requests" description="Employee leave applications will appear here for approval." testId="leaves-empty" />
      ) : (
        <div className="space-y-3" data-testid="leaves-list">
          {leaves.map((l) => (
            <div key={l.id} className="bg-white border border-border/60 rounded-xl p-5 flex flex-wrap items-center justify-between gap-4" data-testid={`leave-${l.id}`}>
              <div>
                <p className="font-semibold text-[#0B1B3D]">{l.name} — <span className="capitalize">{l.type}</span></p>
                <p className="text-xs text-muted-foreground mt-1">{l.from_date} → {l.to_date} · {l.reason || "No reason given"}</p>
              </div>
              <div className="flex items-center gap-2">
                <StatusBadge status={l.status} />
                {l.status === "pending" && (
                  <>
                    <Button size="sm" className="rounded-full bg-emerald-600 hover:bg-emerald-700" onClick={() => reviewLeave(l.id, "approve")} data-testid={`leave-approve-${l.id}`}>Approve</Button>
                    <Button size="sm" variant="outline" className="rounded-full text-red-600 border-red-200" onClick={() => reviewLeave(l.id, "reject")} data-testid={`leave-reject-${l.id}`}>Reject</Button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </TabsContent>
  );
}
